import { currentENV } from 'api';
import Snippets, { SnippetTagsParams } from './snippets';

type DataLayerParams = {
  dataLayer?: unknown;
  dataLayerName?: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: any;

export const gtmENVid = () => {
  switch (currentENV()) {
    case 'prod':
      return 'GTM-N2DX4MV5';

    case 'qa':
      return 'GTM-TTKSS5WQ';

    default:
      return;
  }
};

const TagManager = {
  dataScript: function(dataLayer: string) {
    const script = document.createElement('script');
    script.innerHTML = dataLayer;
    return script;
  },

  gtm: function(params: SnippetTagsParams) {
    const snippets = Snippets.tags(params);

    const noScript = () => {
      const noscript = document.createElement('noscript');
      noscript.innerHTML = snippets.iframe;
      return noscript;
    };

    const scripts = () => {
      // GTM
      const script = document.createElement('script');
      script.innerHTML = snippets.script;

      return [...snippets.onetrustHeaders(), script];
    };

    const dataScript = this.dataScript(snippets.dataLayerVar);

    const onetrustFooter = () => {
      const footer = document.createElement('footer');
      footer.style.position = 'absolute';
      footer.style.bottom = '0';
      footer.style.right = '0';
      footer.innerHTML = snippets.onetrustFooter;
      return footer;
    };

    return {
      noScript,
      scripts,
      dataScript,
      onetrustFooter,
    };
  },

  initialize: function({
    id,
    events = {},
    dataLayer,
    dataLayerName = 'dataLayer',
    auth = '',
    preview = '',
  }: SnippetTagsParams) {
    if (!id) return;

    const gtm = this.gtm({
      id,
      events: events,
      dataLayer: dataLayer || undefined,
      dataLayerName: dataLayerName,
      auth,
      preview,
    });

    if (dataLayer) document.head.appendChild(gtm.dataScript);
    const currentFirst = document.head.childNodes[0];
    for (const script of gtm.scripts()) {
      document.head.insertBefore(script, currentFirst);
    }

    document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);

    // Onetrust Cookie Notification
    document.body.appendChild(gtm.onetrustFooter());
  },

  dataLayer: function({
    dataLayer,
    dataLayerName = 'dataLayer',
  }: DataLayerParams) {
    if (window[dataLayerName]) {
      return window[dataLayerName].push(dataLayer);
    }

    const snippets = Snippets.dataLayer(dataLayer, dataLayerName);
    const dataScript = this.dataScript(snippets);

    document.head.insertBefore(dataScript, document.head.childNodes[0]);
  },
};

export default TagManager;
